import { TimesheetStatus } from "../types/TimesheetStatus";
import agent from "./agent";

interface GetParams {
  status?: TimesheetStatus;
  userId?: string;
  activeDate?: string;
  isWeek?: boolean;
  page?: number;
  perPage?: number;
}

interface BatchCreateData {
  userId: string;
  timesheets: Record<string, string | number>[];
}

const timesheetApi = {
  getTimesheet: (params: GetParams) => agent.get("/timesheet", { params }),
  batchCreateTimesheets: (data: BatchCreateData) => agent.post("/admin/timesheets/batch", data),
  getClockInTypes: (companyId: number) => agent.get(`/admin/clock-in-type/${companyId}`),
};

export default timesheetApi;
